// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { useMemo } from 'react'
import paginateData from './paginateData'

const useCollateData = props => {
  const {
    data,
    filterAndSortData,
    formValues,
  } = props

  // gets the filtered and sorted, full data set
  const filteredAndSortedData = useMemo(() => (
    data.length && formValues
      ? filterAndSortData(data, formValues)
      : data
  ), [data, formValues])

  // if the form has pagination stuff,
  // this will return the subset of data based on paginationPage/paginationPage.
  // otherwise it will just return the full data set it's given.
  const paginatedData = useMemo(() => (
    paginateData(filteredAndSortedData, formValues)
  ), [filteredAndSortedData, formValues])

  return {
    filteredAndSortedData,
    paginatedData,
  }
}

export default useCollateData
